import { Icon } from '@ant-design/compatible';
import { Spin } from 'antd';
import React from 'react';

export const StatisticBox = ({
         label,
         stat,
         loading,
       }: {
         label: string;
         stat: number | string | undefined;
         loading: boolean;
       }) => {
         return (
           <div style={{ padding: '16px', borderRadius: '4px', background: '#e4e5e7', color: '#7d7e82' }}>
             <p>{label}</p>
             <div className="flex items-center" style={{ height: '40px' }}>
               {!loading ? (
                 <span className="text-4xl font-bold tracking-wider">{stat}</span>
               ) : (
                 <Spin indicator={<Icon type="loading" style={{ fontSize: 24, color: '#7d7e82' }} spin />} />
               )}
             </div>
           </div>
         );
       };
